<template>
  <Modal :title="'绑定设备'+dataList.length+'个'" v-model="openForm" footer-hide width="800">
    <bindTool @bind="bind" v-model="dataList"></bindTool
  ></Modal>
</template>
<script>
import bindTool from "./bindTool.vue";
export default {
  props: ["dataList123"],
  components: { bindTool },
  data() {
    return {
      openForm: false,
      dataList:[]
    };
  },
  methods: {
    open() {
      this.openForm = true;
    },
    bind(v) {
      this.$emit("blind", v);
      this.openForm = false;
    },
  },
  model: {
    prop: "dataList123",
    event: "aaa",
  },
  watch: {
    dataList123(v) {
      this.dataList = v;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/blind.vue